import { createFileRoute, lazyRouteComponent } from "@tanstack/react-router";

import { SearchWithStatus, Status } from "../types";

export const Route = createFileRoute("/updates/regions/")({
  validateSearch(search: Record<string, unknown>): SearchWithStatus {
    return {
      status: (search?.status as Status) ?? "all"
    };
  },

  beforeLoad() {
    return { pageName: undefined };
  },

  component: lazyRouteComponent(
    () => import("src/app/pages/updates/allRegions/UpdatesAllRegionsPage")
  )
});
